import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Box from '@mui/material/Box';
import Breadcrumbs from 'components/Breadcrumbs';
import Tabber from 'components/Tabber';
import IntegrationIcon from 'components/IntegrationIcon';
import KiwiSettings from 'components/KiwiSettings';
import FacebookSettings from 'components/FacebookSettings';
import EtgSettings from 'components/EtgSettings';
import PayseraSettings from 'components/PayseraSettings';
import GoogleSettings from 'components/GoogleSettings';
import ScoroSettings from 'components/ScoroSettings';

import { withData } from 'lib';
import { SettingsIntegrationsPageQuery } from '__generated__/SettingsIntegrationsPageQuery.graphql';

const query = graphql`
  query SettingsIntegrationsPageQuery {
    settings {
      ...KiwiSettings_settings
      ...FacebookSettings_settings
      ...EtgSettings_settings
      ...PayseraSettings_settings
      ...GoogleSettings_settings
      ...ScoroSettings_settings
    }

    ...GoogleSettings_data
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<SettingsIntegrationsPageQuery>;
};

const SettingsIntegrationsPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<SettingsIntegrationsPageQuery>(
    query,
    preloadedQuery
  );

  const { settings } = data;

  return (
    <Box>
      <Breadcrumbs
        breadcrumbs={[
          { link: '/settings', name: 'Nustatymai' },
          { name: 'Sąsajos' },
        ]}
      />

      <Tabber
        tabs={[
          {
            title: <IntegrationIcon integration="kiwi" />,
            component: <KiwiSettings settings={settings} />,
            hash: 'kiwi',
          },
          {
            title: <IntegrationIcon integration="facebook" />,
            component: <FacebookSettings settings={settings} />,
            hash: 'facebook',
          },
          {
            title: <IntegrationIcon integration="etg" />,
            component: <EtgSettings settings={settings} />,
            hash: 'etg',
          },
          {
            title: <IntegrationIcon integration="paysera" />,
            component: <PayseraSettings settings={settings} />,
            hash: 'paysera',
          },
          {
            title: <IntegrationIcon integration="google" />,
            component: <GoogleSettings settings={settings} data={data} />,
            hash: 'google',
          },
          {
            title: <IntegrationIcon integration="scoro" />,
            component: <ScoroSettings settings={settings} />,
            hash: 'scoro',
          },
        ]}
      />
    </Box>
  );
};

export default withData<SettingsIntegrationsPageQuery>({
  query,
})(SettingsIntegrationsPage);
